import React from "react";
import solanaIcon from "../../../assets/solanaIcon.svg";
import heartIcon from "../../../assets/heartIcon.svg";
import styles from "./NewestCollection.module.scss";
import { useNavigate } from "react-router-dom";
import { PATHS } from "../../../routes/paths";

const NewestCollection = ({ name, media, type, price, creator, likes }) => {
  const navigate = useNavigate();
  return (
    <div className={styles.container} onClick={() => navigate("/item")}>
      <img src={media} alt={name} className={styles.cover} />
      <div className={styles.textContainer}>
        <h4>{name}</h4>
        <div className={styles.bottom}>
          <p>By {creator}</p>
          <div className={styles.type}>Type: {type}</div>
        </div>
        <hr />
        <div className={styles.footer}>
          <div className={styles.price}>
            <img src={solanaIcon} alt="solana" />
            {price}
            SOL
          </div>
          <div className={styles.likes}>
            {likes}
            <img src={heartIcon} alt="likes" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewestCollection;
